import { useMemo } from 'react';
import { BRAND_KIT_PALETTE_ID, THEME } from 'reporting-data/tsTypes/visualization/colors';
import { useFetchSnowflakeBrandKitColorPalettes } from 'reporting-snowflake/relational/utils/brand-kit-color-palette-utils';
import { useFetchSingleObjectBrandKitColorPalettes } from '../../../reports/hooks/color/useFetchSingleObjectBrandKitColorPalettes';
export const useFetchUnifiedBrandKits = report => {
  var _report$toJS;
  const reportVizChart = report === null || report === void 0 || (_report$toJS = report.toJS()) === null || _report$toJS === void 0 ? void 0 : _report$toJS.chart;
  const {
    theme,
    paletteId
  } = (reportVizChart === null || reportVizChart === void 0 ? void 0 : reportVizChart.color) || {};
  const shouldDeferSOBrandKitFetching = useMemo(() => theme !== THEME.BRAND_KIT, [theme]);
  const shouldDeferSnowflakeBrandKitFetching = useMemo(() => paletteId !== BRAND_KIT_PALETTE_ID, [paletteId]);
  const snowflakeBrandKitPalettes = useFetchSnowflakeBrandKitColorPalettes(undefined, shouldDeferSnowflakeBrandKitFetching);
  const soBrandKitPalettes = useFetchSingleObjectBrandKitColorPalettes(shouldDeferSOBrandKitFetching);
  if (!shouldDeferSnowflakeBrandKitFetching) {
    const {
      isLoading,
      snowflakeBrandKitPaletteMap
    } = snowflakeBrandKitPalettes;
    return {
      areBrandKitsLoading: isLoading,
      brandKitPalettes: snowflakeBrandKitPaletteMap
    };
  } else if (!shouldDeferSOBrandKitFetching) {
    const {
      isLoading,
      soBrandKitMap
    } = soBrandKitPalettes;
    return {
      areBrandKitsLoading: isLoading,
      brandKitPalettes: soBrandKitMap
    };
  }
  return {
    areBrandKitsLoading: false
  };
};